import { put } from '@/utils/apiClient';

export const updateSaleLine: UpdateSaleLine = async (saleLineId, reqBody) => {
  const apiResponse = await put(`/sale-lines/${saleLineId}`, reqBody);
  return apiResponse;
};

export const unlockSaleLine: UnlockSaleLine = async (saleLineId) => {
  const apiResponse = await put(`/sale-lines/${saleLineId}/unlock`, {});
  return apiResponse;
};

// ======================================= Types and Interfaces =======================================
interface UpdateSaleLine {
  (saleLineId: string, reqBody: UpdateSaleLineReqBody): Promise<{
    success: boolean;
    data: any;
  }>;
}

interface UnlockSaleLine {
  (saleLineId: string): Promise<{
    success: boolean;
    data: any;
  }>;
}

// Accepted body for PUT /sale-lines/:saleLineId. The handler does a partial
// update, so the semantics are still: omit a field = leave unchanged, null =
// clear. Unknown keys are rejected with a 400, so this MUST stay in sync with
// the backend allow-list.
export interface UpdateSaleLineReqBody {
  // number → manual override (priceSource: manual); null → clear the override
  // and let the engine reprice; omit → leave price/provenance untouched.
  suggestedPrice?: number | null;
  // Backend-derived for manual prices (client-sent value is advisory). The
  // derivation is reference-aware — references win over a base + adder:
  // 2 refs → series; 1 ref + base/adder → reference_formula; 1 ref → exact;
  // base/adder only → formula; else → static.
  priceType?: 'static' | 'formula' | 'series' | 'exact' | 'reference_formula' | null;
  // Send for formula; omit for series (the backend derives base/adder).
  basePrice?: number | null;
  // Signed (can be negative). Send for formula; omit for series.
  perMeterAdder?: number | null;
  referenceProduct1?: string | null;
  referenceProduct1Length?: number | null;
  referenceProduct1Price?: number | null;
  referenceProduct2?: string | null;
  referenceProduct2Length?: number | null;
  referenceProduct2Price?: number | null;
  cableCost?: number | null;
  laborCost?: number | null;
  otherCosts?: number | null;
  expectedMargin?: number | null;
  priceListId?: string | null;
  enginePrice?: number | null;
  notes?: string;
  /** @deprecated Use perMeterAdder. */
  perFootAdder?: number | null;
  /** @deprecated Legacy field, not consumed by the backend. */
  pricingType?: string | null;
}
